import styled from '@emotion/styled';
import { useRef, useContext } from 'react';
import { useFocusRing, useRadio, VisuallyHidden, mergeProps, useId } from 'react-aria';

import { mergeRefs } from '../../../lib/mergeRefs';

import { su } from '../../../theme/functions/su';
import { theme } from '../../../theme/theme';

import { RadioContext } from './RadioGroup';
import { RadioIndicator } from './RadioIndicator';

export function Radio(props) {
  const radioRef = useRef();
  const context = useContext(RadioContext);
  const radio = useRadio({ ...props, children: props.description }, context.state, radioRef);
  const focusRing = useFocusRing();

  const { ref: registerRef, ...registerProps } =
    context.register?.(context.name, {
      required: props.required,
    }) ?? {};

  const titleId = useId();
  // const descriptionId = useId();

  return (
    <S.Label>
      <VisuallyHidden>
        <input
          {...mergeProps(radio.inputProps, focusRing.focusProps, registerProps)}
          ref={mergeRefs([registerRef, radioRef])}
          aria-labelledby={titleId}
          // aria-describedby={descriptionId}
        />
      </VisuallyHidden>

      <S.Title id={titleId}>{props.title}</S.Title>

      <RadioIndicator
        isSelected={radio.isSelected}
        isDisabled={radio.isDisabled}
        isFocusVisible={focusRing.isFocusVisible}
      />
      {/* <SRadio.Description id={descriptionId}>{props.description}</SRadio.Description> */}
    </S.Label>
  );
}

function S() {}
Radio.S = S;

S.Label = styled.label`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  height: ${su(5)};
  font-size: ${theme.fontSize.regular};
  cursor: pointer;
`;

S.Title = styled.div``;
